import $ from 'jquery'
function isUndefined(val) {
	return typeof val == 'undefined' ? true : false;
}

function hash(string, length) {
	var length = length ? length : 32;
	var start = 0;
	var i = 0;
	var result = '';
	var filllen = length - string.length % length;
	for(i = 0; i < filllen; i++){
		string += "0";
	}
	while(start < string.length) {
		result = stringxor(result, string.substr(start, length));
		start += length;
	}
	return result;
}

function in_array(needle, haystack){
	if(typeof haystack == 'undefined')return false;
	if(typeof needle == 'string' || typeof needle == 'number'){
		for(var i in haystack){
			if(haystack[i] == needle){
				return true;
			}
		}
	}
	return false;
}

function $id(id) {
	return document.getElementById(id) ? document.getElementById(id) : null;
}


// url search 获取
export function parseUrlSearch(getStr){
	var changeObject = {}, arr = [];
        var str = getStr.split('?')[1];
        if (!str) {
            return false;
        }
        //将字符串以&为分割点转换成数组
        arr = str.split("&");
        //循环字符串转换为了对应键值的对象,字符串必须是ey=main_choose_grade_id&value=3格式
        for(var i = 0; i < arr.length; i ++) {
          changeObject[arr[i].split("=")[0].toLowerCase()] = (arr[i].split("="))[1];
        }
        return changeObject;
}
export function isWeiXin(){
	if(window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
		return true;
	}
	return false;
}

function isWeibo(){
	if (navigator.userAgent.match(/weibo/i)) return true;
    else return false;
}

export function appendscript(src, text, callback, reload, targetid, charset) {
	var JSLOADED = [];/*javascript动态载入标识数组*/
	var evalscripts = [];/*js相关*/
	var src = isUndefined(src) ? '' : src;
	var text = isUndefined(text) ? '' : text;
	var callback = isUndefined(callback) ? '' : callback;
	var targetid = (isUndefined(targetid) || targetid == '' || targetid == null) ? 'htmlhead' : targetid;
	var reload = isUndefined(reload) ? 0 : (parseInt(reload) == 1 ? 1 : 0);
	var charset = isUndefined(charset) ? '' : charset;
	var id = hash(src + text);
	if(!src && !text) return;
	if(targetid != 'htmlhead' && targetid != 'htmlbody' && !$id(targetid)) return;
	if(!reload && in_array(id, evalscripts)) return;
	if(reload && $id(id)) {
		$id(id).parentNode.removeChild($id(id));
	}

	evalscripts.push(id);
	var scriptNode = document.createElement("script");
	scriptNode.type = "text/javascript";
	scriptNode.id = id;
	scriptNode.charset = charset ? charset : '';
	try {
		if(src) {
			scriptNode.src = src;
			scriptNode.onloadDone = false;
			scriptNode.onload = function () {
				scriptNode.onloadDone = true;
				JSLOADED[src] = 1;
				if(callback)
					try{eval('callback()')} catch(e) {}
			};
			scriptNode.onreadystatechange = function () {
				if((scriptNode.readyState == 'loaded' || scriptNode.readyState == 'complete') && !scriptNode.onloadDone) {
					scriptNode.onloadDone = true;
					JSLOADED[src] = 1;
					if(callback)
						try{eval('callback()')} catch(e) {}
				}
			};
		} else if(text){
			scriptNode.text = text;
		}
		if(targetid == 'htmlhead') {
			document.getElementsByTagName('head')[0].appendChild(scriptNode);
		} else if(targetid == 'htmlbody') {
			document.getElementsByTagName('body')[0].appendChild(scriptNode);
		} else {
			$id(targetid).appendChild(scriptNode);
		}
	} catch(e) {}
}
export function getClientName () {
	if (navigator.userAgent.match(/iphone|ipad|ios/i)) {
		return "ios";
	} else if (navigator.userAgent.match(/android/i)) {
		return "android";
	} else {
		return "pc";
	}
}
export function sogouDownload(url){
	let ua = navigator.userAgent
	let clientName = getClientName()
	if(clientName === 'ios'){
		if (ua.match(/ipad/i)) {
			if (isWeibo()) {
				$('body').append(maskShareTpl('ipadwb'));
				return false;
			} else {
				window.location = url
			}
		} else {
			if (isWeibo()) {
				$('body').append(maskShareTpl('iOS_WB'));
				return false;
			} else {
				window.location = url
			}
		}
	}else{
		window.location = url;
	}
}

function stringxor(s1, s2) {
	var s = '';
	var hash = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
	var max = Math.max(s1.length, s2.length);
	for(var i=0; i<max; i++) {
		var k = s1.charCodeAt(i) ^ s2.charCodeAt(i);
		s += hash.charAt(k % 52);
	}
	return s;
}
function maskShareTpl(platform) {
    var tpl = [
        '<div class="maskWrap" id="maskWrap" style="width:100%;height:100%;position:fixed;top:0;left:0;background:rgba(0,0,0,0.7);z-index:999;">',
		'<img src="//img.shouji.sogou.com/wapdl/hole/201903/06/' + platform + '.png?t=20190307" style="display:block;width:100%"/></div>',
		'<script type="text/javascript">$("#maskWrap").click(function(){this.remove();})</script>'].join("");

    return tpl;
}